import axios from 'axios';
import { domain } from './domain';

export const getQuestions = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: { 
            'Authorization' : 'Bearer ' + token,
            'Content-type': 'application/json' 
        },
        data,
    };
    return axios(domain + '/getquestionsmaster', requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            } else {
                throw new Error('Bağlantı hatası!');
            }
        })
        .catch((error) => {
            return error;
        });
};

export const getConservation = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: { 
            'Authorization' : 'Bearer ' + token,
            'Content-type': 'application/json' 
        },
        data,
    };
    return axios(domain + '/getconversation', requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            } else {
                throw new Error('Bağlantı hatası!');
            }
        })
        .catch((error) => {
            return error;
        });
};

export const updateQuestion = (token, data) => {
    const requestOptions = {
        method: 'PUT',
        headers: { 
            'Content-type': 'application/json',
            'Authorization' : "Bearer " + token
        },
        data
    };
    return axios(domain + '/questionmaster', requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            } else {
                throw new Error('Bağlantı hatası!');
            }
        })
        .catch((error) => {
            return error;
        });
};

export const updateQuestionAudio = (token, data) => {
    const requestOptions = {
        method: 'PUT',
        headers: { 
            'Content-type': 'application/json',
            'Authorization' : "Bearer " + token
        },
        data
    };
    return axios(domain + '/questionaudiomaster', requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            } else {
                throw new Error('Bağlantı hatası!');
            }
        })
        .catch((error) => {
            return error;
        });
};

export const getUserQuestions = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: { 
            'Authorization' : 'Bearer ' + token,
            'Content-type': 'application/json' 
        },
        data,
    };
    return axios(domain + '/getuserrecentquestions', requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            } else {
                throw new Error('Bağlantı hatası!');
            }
        })
        .catch((error) => {
            return error;
        });
};

